import { useCallback, useEffect, useState } from "react";
import MultiItemSelectDropdown from "../inputs/MultiItemSelectDropdown";
import AppContext from "../context/AppContext";
import SelectDropdown from "../inputs/SelectDropdown";
import { getDatePlus, getSupplierLocationsUrl, getTravellers } from "../utils";
import FromToDateField from "../inputs/FromToDateField";

export default function EasyOTAFormCarHire({ onSubmit, supplierId, supplierSettings }) {
   const [locations, setLocations] = useState([]);
   const [submitData, setSubmitData] = useState({
      rooms: 1,
      nights: 1,
   });
   const [popupsListeners, setPopupsLisners] = useState([]);
   const travellersItems = getTravellers(supplierSettings);
   const [travellers, setTravellers] = useState({});
   const popupCloseEvent = () => {
      popupsListeners.forEach((handler) => {
         handler();
      });
   };

   const registerPops = useCallback((handler) => {
      setPopupsLisners((prev) => {
         return [...prev, handler];
      });
   }, []);

   const handleOnChange = useCallback(({ name, value }) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            [name]: value,
         };
      });
      if (name === "departure_date") {
         setSubmitData((prev) => {
            return {
               ...prev,
               return_date: undefined,
            };
         });
      }
   }, []);

   const handleSubmit = (ev) => {
      ev.preventDefault();
      onSubmit && onSubmit({ ...submitData, travellers });
   };
   const handleOnChangeMult = useCallback((params) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            ...params,
         };
      });
   }, []);

   useEffect(() => {
      if (supplierId) {
         fetch(getSupplierLocationsUrl(supplierId))
            .then((res) => res.json())
            .then((json) => {
               setLocations(json);
            });
      }
   }, [supplierId]);
   return (
      <AppContext.Provider value={{ registerPopupListener: registerPops, popupCloseEvent }}>
         <div className='form'>
            <form action='#' method='post' id='search-form' onSubmit={handleSubmit} autoComplete='off'>
               <div className='fields'>
                  <SelectDropdown
                     field='location'
                     label='Pickup From'
                     hint='Choose a pickup location'
                     options={locations}
                     onChange={handleOnChange}
                     defaultOption={supplierSettings.defaultPickupLocation}
                  />
                  <SelectDropdown
                     field='dropoff'
                     label='Drop Off To'
                     hint='Choose a dropoff location'
                     options={locations}
                     onChange={handleOnChange}
                  />
                  <FromToDateField
                     params={{
                        from: {
                           field: "departure_date",
                           label: "From",
                           withTime: {
                              field: "departure_time",
                              label: "Pickup Time",
                           },
                        },
                        to: {
                           field: "return_date",
                           label: "To",
                           withTime: {
                              field: "return_time",
                              label: "Dropoff Time",
                           },
                           minDate: getDatePlus(0),
                        },
                        noOneway: true,
                     }}
                     minDate={new Date()}
                     required
                     onChange={handleOnChangeMult}
                  />
                  <MultiItemSelectDropdown
                     field='travellers'
                     label='Travellers'
                     items={travellersItems}
                     data={travellers}
                     settings={supplierSettings}
                     onChange={(selected) => {
                        setTravellers((prev) => {
                           return {
                              ...prev,
                              ...selected,
                           };
                        });
                     }}
                     required
                     validity='You must select atleast 1 adult'
                  />
               </div>
               <button className='btn'>Search</button>
            </form>
         </div>
      </AppContext.Provider>
   );
}
